import type { GoalMoment } from "~vue/api/generated/development-journeys";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";

export const GOAL_PROGRESS_VIEW_METHOD = {
    TOOLTIP: "tooltip",
    MODAL: "modal",
} as const;

export const GOAL_PROGRESS_WEEK_CONTEXT = {
    PAST: "past",
    CURRENT: "current",
    FUTURE: "future",
} as const;

export type GoalProgressViewMethod = (typeof GOAL_PROGRESS_VIEW_METHOD)[keyof typeof GOAL_PROGRESS_VIEW_METHOD];

interface GoalProgressViewedProperties {
    goal_progress_view_method: GoalProgressViewMethod;
    week_context: (typeof GOAL_PROGRESS_WEEK_CONTEXT)[keyof typeof GOAL_PROGRESS_WEEK_CONTEXT];
    week_action_commitment_count: number;
    week_action_completion_count: number;
    week_goal_count: number;
    week_goal_moment_count: number;
    week_goal_moment_types: GoalMoment["kind"][];
}

export const logGoalProgressPageViewed = () => logUserInteraction(AmplitudeEventNames.DEVELOPMENT_JOURNEYS_GOAL_PROGRESS_PAGE_VIEWED);

export const logGoalProgressViewed = (properties: GoalProgressViewedProperties) => logUserInteraction(AmplitudeEventNames.DEVELOPMENT_JOURNEYS_GOAL_PROGRESS_VIEWED, properties);
